import React, { Component } from 'react';
import { NavLink, Switch, Route, Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { NavHashLink } from 'react-router-hash-link';

import get from 'lodash/get';
import Sidebar from "react-sidebar";

import PageNotFound from 'shared/PageNotFound';
import Text from 'ui/Text';
import PageTitle from 'shared/PageTitle';

import { LayoutSubject } from 'shared/LayoutSubject';
import Faqs from 'components/HomePage/Faqs';
import LandingPageItems from 'components/HomePage/LandingPageItems';
import SignInPage from 'components/HomePage/SignInPage';
import SignUpPage from 'components/HomePage/SignUpPage';
import PasswordResetPage from 'components/HomePage/PasswordResetPage';
import DataPolicy from 'components/HomePage/DataPolicy';
import Footer from 'components/HomePage/Footer';
import epicLogo from 'assets/epic-logo.jpeg';
import Auth from 'shared/Auth';
import CSOSearchPage from 'components/HomePage/CSOSearchPage';

class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homeLayoutActive: this.props.showHome || false,
      activeRoute: this.props.activeRoute || '/',
      sidebarOpen: false,
      flashMessage: '',
    };
  }

  componentDidMount() {
    this.setState({ flashMessage: Auth.getFlashMessage() });

    // Scroll to the point of interest
    this.setState({ flashMessage: Auth.getFlashMessage() });

    const el = document.querySelector(`a.nav-menu__item[href="${this.props.activeRoute}"]`);
    if (el) el.click();
  }

  activateQuestionnaire = (activeRoute) => {
    LayoutSubject.next({ activeRoute, showHome: false, showApplicationPage: false });
  };

  toggleSideBar = () => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen });
  }

  render() {
    const { changeLanguage, currentLocale, defaultLocale } = this.props;

    const locale = get(currentLocale, 'lang') === get(defaultLocale, 'lang')
            ? {
              lang: 'fr_FR',
              local_locale: 'fr',
            }
            : {
              lang: 'en_US',
              local_locale: 'en',
            };

    const language = get(currentLocale, 'lang') === get(defaultLocale, 'lang') ? 'Français' : 'English';

    const sidebarContent = (
      <div className="sidebar">
        <ul className="nav-menu__container mobile">
          <li className="nav-menu__wrapper">
            <NavHashLink smooth exact className="nav-menu__item" to="/#about">
              <Text modifiers="uppercase">
                <FormattedMessage id="AboutAwards" defaultMessage="About the Awards" />
              </Text>
            </NavHashLink>
          </li>
          <li className="nav-menu__wrapper">
            <NavHashLink smooth exact className="nav-menu__item" to="/#partners">
              <Text modifiers="uppercase">
                <FormattedMessage id="Partners" defaultMessage="Partners" />
              </Text>
            </NavHashLink>
          </li>
          <li className="nav-menu__wrapper">
            <NavHashLink smooth exact className="nav-menu__item" to="/#who-we-are">
              <Text modifiers="uppercase">
                <FormattedMessage id="Header.WhoWeAre" defaultMessage="Who We Are" />
              </Text>
            </NavHashLink>
          </li>
          <li className="nav-menu__wrapper">
            {this.state.homeLayoutActive ? (
              <span role="Application Button" onClick={() => this.activateQuestionnaire()} className="nav-menu__item">
                <Text modifiers="uppercase">
                  <FormattedMessage id="Header.ToApplication" defaultMessage="To Application" />
                </Text>
              </span>
            ) : null}
          </li>
          <li className="nav-menu__wrapper no-border">
            <NavLink exact className="nav-menu__item" to="/faqs">
              <Text modifiers="uppercase">
                <FormattedMessage id="Header.FAQ" defaultMessage="FAQ" />
              </Text>
            </NavLink>
          </li>
          <li className="nav-menu__wrapper">
            <a onClick={() => changeLanguage(locale)} className="header-cta nav-menu__item">
              <Text>{language}</Text>
            </a>
          </li>          
          <li className="nav-menu__wrapper">
            <span onClick={this.toggleSideBar} className="nav-menu__item">
              <Text modifiers="uppercase">
                <FormattedMessage id="Header.Close" defaultMessage="Close" />
              </Text>
            </span>
          </li>          
        </ul>  
      </div>
    )

    return (
      <Sidebar
        sidebar={sidebarContent}
        sidebarClassName="mobile-nav"
        open={this.state.sidebarOpen}
      >
        <div>
          <PageTitle title="Home"/>
          {
            this.state.flashMessage ? (
              <Text type="normal-bold" modifiers="flash-message">{this.state.flashMessage}</Text>
            ) : null
          }          
          <div className="mobile-menu flex align-items-center justify-content-between">
            <NavLink to="/">
              <img src={epicLogo} className="logo" alt="Logo"/>
            </NavLink>
            <Text type="normal-semi-bold" modifiers="uppercase" onClick={this.toggleSideBar}>
              <FormattedMessage id="Menu" defaultMessage="Menu" />
            </Text>
          </div>
          <div className="row no-margin">
            <div className="full-width justify-content-center">
              <div className="flex full-width align-items-center justify-content-between header">
                <NavLink to="/">
                  <img src={epicLogo} className="logo" alt="Logo" />
                </NavLink>
                <ul className="nav-menu__container">
                  <li className="nav-menu__wrapper">
                    <NavHashLink smooth exact className="nav-menu__item" to="/#shortlisted-csos">
                      <Text modifiers="uppercase">
                        <FormattedMessage id="ShortlistedCSOs" defaultMessage="Shortlisted CSOs" />
                      </Text>
                    </NavHashLink>
                  </li>
                  <li className="nav-menu__wrapper">
                    <NavHashLink smooth exact className="nav-menu__item" to="/search-csos#search-csos">
                      <Text modifiers="uppercase">
                        <FormattedMessage id="SearchCSOs" defaultMessage="Search CSOs" />
                      </Text>
                    </NavHashLink>
                  </li> 

                  <li className="nav-menu__wrapper">
                    <NavHashLink smooth exact className="nav-menu__item" to="/data-protection-policy">
                      <Text modifiers="uppercase">
                        <FormattedMessage id="DataProtectionPolicy" defaultMessage="Data Protection Policy" />
                      </Text>
                    </NavHashLink>
                  </li> 
               
                  <li className="nav-menu__wrapper">
                    <NavHashLink smooth exact className="nav-menu__item" to="/#about">
                      <Text modifiers="uppercase">
                        <FormattedMessage id="AboutAwards" defaultMessage="About the Awards" />
                      </Text>
                    </NavHashLink>
                  </li>
                  <li className="nav-menu__wrapper">
                    <NavHashLink smooth exact className="nav-menu__item" to="/#judges">
                      <Text modifiers="uppercase">
                        <FormattedMessage id="Judges" defaultMessage="Judges" />
                      </Text>
                    </NavHashLink>
                  </li>                  
                  <li className="nav-menu__wrapper">
                    <NavHashLink smooth exact className="nav-menu__item" to="/#partners">
                      <Text modifiers="uppercase">
                        <FormattedMessage id="Partners" defaultMessage="Partners" />
                      </Text>
                    </NavHashLink>
                  </li>
                  <li className="nav-menu__wrapper">
                    <NavHashLink smooth exact className="nav-menu__item" to="/#who-we-are">
                      <Text modifiers="uppercase">
                        <FormattedMessage id="Header.WhoWeAre" defaultMessage="Who We Are" />
                      </Text>
                    </NavHashLink>
                  </li>                 
                  <li className="nav-menu__wrapper faq-item">
                    {this.state.homeLayoutActive ? (
                      <span role="Application Button" onClick={() => this.activateQuestionnaire()} className="nav-menu__item">
                        <Text modifiers="uppercase">
                          <FormattedMessage id="Header.ToApplication" defaultMessage="To Application" />
                        </Text>
                      </span>
                    ) : null}
                  </li>
                  {/* <li className="nav-menu__wrapper faq-item">
                    <NavLink exact className="nav-menu__item" to="/faqs">
                      <Text type="normal-bold" modifiers="uppercase">
                        <FormattedMessage id="Header.FAQ" defaultMessage="FAQ" />
                      </Text>
                    </NavLink>
                  </li>                    */
                  }
                  {this.state.homeLayoutActive ? null : (
                    <li className="nav-menu__wrapper">
                      <NavLink exact className="header-cta nav-menu__item bg-light-blue" to="/login">
                        <Text type="tiny-bold" modifiers="uppercase"><FormattedMessage id="Login" defaultMessage="Login" /></Text>
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-menu__wrapper">
                    <a onClick={() => changeLanguage(locale)} className="header-cta nav-menu__item">
                      <Text>{language}</Text>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="main-content full-width">
              <Switch>
                <Route path="/" exact component={LandingPageItems} />
                <Route path="/data-protection-policy" exact component={DataPolicy}/>
                <Route path="/faqs" exact component={Faqs} />
                <Route path="/apply-now" exact component={SignUpPage} />
                <Route path="/login" exact component={SignInPage} />
                <Route path="/reset-password" exact component={PasswordResetPage} />
                <Route path="/search-csos" exact component={CSOSearchPage} />
                {this.state.homeLayoutActive ? <Redirect to={this.state.activeRoute} /> : null}
                <Redirect from="/section/:id" to="/" />
                <Route component={PageNotFound} />
              </Switch>
            </div>
            <Footer />
          </div>
        </div>
      </Sidebar>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Layout/LandingPage.js